const METADATA_TYPES = {
  INGREDIENTS: {
    value: 'INGREDIENTS',
    valueSingular: 'INGREDIENT',
    label: 'Ingredients',
    labelSingular: 'Ingredient',
    key: 'ingredients',
  },
  DISH_TYPES: {
    value: 'DISH_TYPES',
    valueSingular: 'DISH_TYPE',
    label: 'Dish Types',
    labelSingular: 'Dish Type',
    key: 'dishTypes',
  },
  COURSE_TYPES: {
    value: 'COURSE_TYPES',
    valueSingular: 'COURSE_TYPE',
    label: 'Course Types',
    labelSingular: 'Course Type',
    key: 'courseTypes',
  },
  CUISINE_TYPES: {
    value: 'CUISINE_TYPES',
    valueSingular: 'CUISINE_TYPE',
    label: 'Cuisine Types',
    labelSingular: 'Cuisine Type',
    key: 'cuisineTypes',
  },
  AWARDS: {
    value: 'AWARDS',
    valueSingular: 'AWARD',
    label: 'Awards',
    labelSingular: 'Award',
    key: 'awards',
  },
  LOCATION_TYPES: {
    value: 'LOCATION_TYPES',
    valueSingular: 'LOCATION_TYPE',
    label: 'Location Types',
    labelSingular: 'Location Type',
    key: 'locationTypes',
  },
  DIET_CATEGORIES: {
    value: 'DIET_CATEGORIES',
    valueSingular: 'DIET_CATEGORY',
    label: 'Diet Categories',
    labelSingular: 'Diet Category',
    key: 'dietCategories',
  },
  DIETS: {
    value: 'DIETS',
    valueSingular: 'DIET',
    label: 'Diets',
    labelSingular: 'Diet',
    key: 'diets',
  },
  ALLERGENS: {
    value: 'ALLERGENS',
    valueSingular: 'ALLERGEN',
    label: 'Allergens',
    labelSingular: 'Allergen',
    key: 'allergens',
  },
}

export default METADATA_TYPES
